const createSuccessIcon = () =>
  '<svg class="size-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>';

const createLoadingSpinner = () =>
  '<svg class="animate-spin size-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';

const addToCart = (variantId, quantity = 1) =>
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ id: variantId, quantity }),
  }).then(response => response.json());

const getCart = () => fetch('/cart.js').then(response => response.json());

const updateCartCount = selector => cart => {
  const element = document.querySelector(selector);
  if (element) {
    element.textContent = cart.item_count;
  }
  return cart;
};

const setButtonState = (button, { disabled, className, content }) => {
  const modifiedButton = button;
  modifiedButton.disabled = disabled;
  if (className) {
    modifiedButton.classList.add(className);
  }
  if (content !== undefined) {
    modifiedButton.innerHTML = content;
  }
  return modifiedButton;
};

const removeButtonClass = (button, className) => {
  button.classList.remove(className);
  return button;
};

const delay = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

const handleAddToCartSuccess = (button, originalContent) => async data => {
  setButtonState(button, {
    disabled: true,
    className: 'bg-green-500',
    content: createSuccessIcon(),
  });

  await getCart().then(updateCartCount('[data-cart-count]'));

  // Dispatch custom event for slide cart
  document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));

  await delay(2000);

  removeButtonClass(button, 'bg-green-500');
  setButtonState(button, {
    disabled: false,
    content: originalContent,
  });
};

const handleAddToCartError = (button, originalContent) => async error => {
  // eslint-disable-next-line no-console
  console.error('Error adding to cart:', error);

  setButtonState(button, {
    disabled: true,
    className: 'bg-red-500',
  });

  await delay(2000);

  removeButtonClass(button, 'bg-red-500');
  setButtonState(button, {
    disabled: false,
    content: originalContent,
  });
};

const handleAddToCartClick = event => {
  event.preventDefault();
  event.stopPropagation();

  const button = event.currentTarget;
  const variantId = button.getAttribute('data-variant-id');
  const quantity = parseInt(button.getAttribute('data-quantity'), 10) || 1;
  const originalContent = button.innerHTML;

  setButtonState(button, {
    disabled: true,
    content: createLoadingSpinner(),
  });

  addToCart(variantId, quantity)
    .then(handleAddToCartSuccess(button, originalContent))
    .catch(handleAddToCartError(button, originalContent));
};

const attachAddToCartListeners = selector => {
  const buttons = document.querySelectorAll(selector);
  buttons.forEach(button => {
    button.addEventListener('click', handleAddToCartClick);
  });
};

const initializeATC = () => {
  attachAddToCartListeners('.js-add-to-cart-btn');
};

document.addEventListener('DOMContentLoaded', initializeATC);
